import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { get, flowRight as compose } from 'lodash';

import { QUERY_GET_ENTITY_TYPES } from './gql';
import withAuth from '../../../../hocs/withAuth';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

class ConnectorEntity extends React.Component {
  getData = () => {
    const { entityType, auth } = this.props;
    const connectorEntityTypes = get(entityType, 'AdminQueries.getConnectorEntityTypes', []);

    return {
      entityType: connectorEntityTypes,
      admin: auth.me
    };
  };

  getError = () => {
    const { entityType } = this.props;
    return {
      connectionError: entityType.error
    };
  };

  getLoading = () => {
    const { entityType } = this.props;
    return {
      connectionLoading: entityType.loading
    };
  };

  render() {
    const { children } = this.props;
    const renderProps = {
      data: this.getData(),
      error: this.getError(),
      loading: this.getLoading()
    };
    return children(renderProps);
  }
}

ConnectorEntity.propTypes = {
  children: ReactChildrenPropType.isRequired,
  entityType: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.shape({}),
    refetch: PropTypes.func
  }).isRequired,
  auth: PropTypes.shape({
    me: PropTypes.shape({})
  }).isRequired
};

export const ConnectorEntityContainer = compose(
  withAuth(),
  graphql(QUERY_GET_ENTITY_TYPES, {
    name: 'entityType',
    options: () => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: (props) => props
  })
)(ConnectorEntity);
